import { IApiMediaWithCropsModel } from '@shared/integrations/umbraco-taf-delivery-api/models';

interface IBookingObjectImages {
    title?: string;
    images: IApiMediaWithCropsModel[];
}

const ImagesModal = ({ title, images }: IBookingObjectImages) => {
    return (
        <>
            <button
                type='button'
                className='btn btn-primary position-absolute bottom-0 right-0 m-3'
                data-toggle='modal'
                data-target='#images-modal'
            >
                Visa alla bilder
            </button>
            <div
                className='modal fade'
                id='images-modal'
                tabIndex={-1}
                aria-labelledby='images-modal-label'
                aria-hidden='true'
            >
                <div className='modal-dialog modal-xl'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5
                                className='modal-title'
                                id='images-modal-label'
                            >
                                {title ?? 'Bilder'}
                            </h5>
                            <button
                                type='button'
                                className='btn btn-light'
                                data-dismiss='modal'
                                aria-label='Close'
                            >
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className='modal-body'>
                            <div className='d-flex flex-wrap flex-column row-gap-3'>
                                {images.map((x) => (
                                    <img
                                        alt=''
                                        className='ar-1-1 object-cover'
                                        src={`${x.url}?width=1194`}
                                        key={x.id}
                                    />
                                ))}
                            </div>
                        </div>
                        <div className='modal-footer'>
                            <button
                                type='button'
                                className='btn btn-primary'
                                data-dismiss='modal'
                            >
                                Stäng
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImagesModal;
